<script setup>
import CustomLink from '../Components/CustomLink.vue'
import Button from '../Components/Button.vue';
import moment from 'moment';
import "moment/dist/locale/nl"

const navigation = {
    navigation: [
        { name: 'Het Zwagers team', href: '/overons#team' },
        { name: 'Contact', href: '/overons#contactform' },
        { name: 'Vind mijn auto', href: '/overons#ideale-auto' },
    ],
    support: [
        { name: 'Aanbod', href: '/aanbod' },
        { name: 'Zoeken', href: '/zoeken' },
        { name: 'APK', href: '/services' },
        { name: 'Onderhoud', href: '/services' },
    ],
    legal: [
        { name: 'Privacy verklaring', href: '/privacy' },
        { name: 'Algemene voorwaarden', href: '/voorwaarden' },
    ],
}
</script>

<template>
    <footer class="bg-black text-white">
        <div class="w-full relative xl:mx-auto max-w-7xl px-6 lg:px-8 xl:px-16 pb-8 pt-16 md:pt-20 space-y-12">
            <div class="flex flex-col md:flex-row gap-5 items-center justify-between">
                <div class="space-y-5 w-full">
                    <h6>Toch niet helemaal wat je zoekt?</h6>
                    <p class="text-balance">Wij helpen je graag! Wij zorgen ervoor dat je snel en zorgeloos de weg op kunt in jouw auto!</p>
                </div>
                <div class="flex flex-col md:flex-row w-full justify-end gap-5">
                    <CustomLink href="/overons#contactform" :useInertia="false" type="href" class="primary-button">
                        Contact
                    </CustomLink>
                    <!--TO WHATSAPP TEL:-->
                    <CustomLink target="_blank" :useInertia="false" href="https://wa.me/+31617328160" type="href" class="secondary-white-button">
                        <font-awesome-icon :icon="['fab', 'whatsapp']" class="h-5 w-5" /> Whatsapp
                    </CustomLink>
                </div>
            </div>
            <div class="md:border-t border-white md:pt-12 xl:grid xl:grid-cols-8 xl:gap-8 mt-8">
                <div class="grid grid-cols-3 xl:flex xl:flex-col xl:col-span-3 gap-4">
                    <CustomLink href="/" class="-m-1.5 p-1.5 col-span-2 mb-5">
                        <span class="sr-only">Zwagers Automotive</span>
                        <img class="h-9 sm:h-12 lg:h-20" :src="'/img/logo_dark.webp'" alt="c-o-d-e-s logo" />
                    </CustomLink>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-8 xl:mt-0 xl:col-span-5">
                    <div>
                        <h3 class="text-xl font-semibold">Zwagers Automotive</h3>
                        <ul role="list" class="mt-4 space-y-2">
                            <li v-for="item in navigation.navigation" :key="item.name">
                                <CustomLink :href="item.href" class="cursor-pointer text-lg hover:underline">{{ item.name }}</CustomLink>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h3 class="text-xl font-semibold">Services</h3>
                        <ul role="list" class="mt-4 space-y-2">
                            <li v-for="item in navigation.support" :key="item.name">
                                <CustomLink :href="item.href" class="cursor-pointer text-lg hover:underline">{{ item.name }}</CustomLink>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h3 class="text-xl font-semibold">Disclaimers</h3>
                        <ul role="list" class="mt-4 space-y-2">
                            <li v-for="item in navigation.legal" :key="item.name">
                                <CustomLink :href="item.href" class="cursor-pointer text-lg hover:underline">{{ item.name }}</CustomLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="mt-12 border-t border-white pt-8 flex flex-wrap md:items-center justify-between gap-x-8">
                <div class="text-lg md:mt-0 flex flex-row gap-2">
                    <p>&copy; {{moment().year()}} </p>
                    <span class="select-none">&middot;</span>
                    <p>Zwagers Automotive</p>
                </div>
                <div class="flex gap-x-6 md:order-2">
                    <p class="text-lg">Gemaakt door 
                        <CustomLink :useInertia="false" href="https://www.c-o-d-e-s.com/" target="_blank" class="cursor-pointer text-lg hover:underline text-nowrap">c-o-d-e-s</CustomLink>
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>
